// Module
var code = "<h2 id=\"do-you-have-private-education-loans\">Do You Have Private Education Loans?</h2> <p>Find out what special benefits are available for these loans.</p> ";
// Exports
export default code;